import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { TopNavigationBarItem } from "./TopNavigationBarItem";
import { SideBarNavigationItem } from "./SideBarNavigationItem";
import { UserInfo } from "../user_profile/UserInfo";
import {
  userNavigationAction,
  houseNavigationAction,
  financeNavigationAction,
  garageNavigationAction,
} from "../../redux/actions/index";

export const TopNavigationBar = () => {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const activeParent = useSelector(
    (state: any) => state.sideNavigation.activeParent
  );
  const navigationElements = useSelector(
    (state: any) => state.sideNavigation.elements
  );

  let handleContextChange = (itemId: string) => {
    setIsMenuOpen(false);

    switch (itemId) {
      case "Uživatel":
        dispatch(userNavigationAction());
        break;

      case "Domácnost":
        dispatch(houseNavigationAction());
        break;

      case "Finance":
        dispatch(financeNavigationAction());
        break;

      case "Garáž":
        dispatch(garageNavigationAction());
        break;
    }
  };

  return (
    <nav className="flexible-navbar fixed-top navbar-expand-xl navbar-light white scrolling-navbar">
      <div className="container-fluid">
        {/*<!-- Collapse -->*/}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-controls="navbarSupportedContent"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* <!-- Links -->*/}
        <div
          className={"collapse navbar-collapse" + (isMenuOpen ? " show" : "")}
          id="navbarSupportedContent"
        >
          {/* <!-- Left -->*/}
          <ul className="navbar-nav mr-auto">
            <TopNavigationBarItem
              id="Uživatel"
              handleClick={handleContextChange}
              iconClassName="far fa-user"
              text="Uživatel"
              link="/userhomepage"
              isActive={activeParent === "Uživatel"}
            />
            <TopNavigationBarItem
              id="Domácnost"
              handleClick={handleContextChange}
              iconClassName="fas fa-home"
              text="Domácnost"
              link="/househomepage"
              isActive={activeParent === "Domácnost"}
            />
            <TopNavigationBarItem
              id="Finance"
              handleClick={handleContextChange}
              iconClassName="fas fa-chart-line"
              text="Finance"
              link="/financehomepage"
              isActive={activeParent === "Finance"}
            />
            <TopNavigationBarItem
              id="Garáž"
              handleClick={handleContextChange}
              iconClassName="fas fa-car"
              text="Garáž"
              link="/garagehomepage"
              isActive={activeParent === "Garáž"}
            />
          </ul>

          {/* Boční navigace je na malých displejích skrytá, proto ji nabízíme zde */}
          <div
            className="mobile-side-navigation list-group list-group-flush d-xl-none"
            onClick={() => setIsMenuOpen(false)}
          >
            {navigationElements.map((element: any, index: number) => (
              <SideBarNavigationItem
                key={index}
                text={element.text}
                link={element.link}
                iconClassName={element.iconClassName}
                isActive={window.location.href.indexOf(element.link) >= 0}
              />
            ))}
          </div>

          {/*<!-- Right -->*/}
          <ul className="navbar-nav nav-flex-icons">
            <li className="nav-item">
              <UserInfo />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
